


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as MicroUtils from '../../utils'
import { env } from '@ivy/fts/envInfo/envInfo'
import { translateUrl } from '@/api/goods/statistics'

@Component({})
export default class Modal extends Vue {
  @Prop() data: any
  @Prop() item: any
  @Prop() uploadEvent: any
  showDesc: boolean = false

  get getSrc() {
    return this.data.imgUrl
      ? this.data.imgUrl
      : require('../../images/modal-pic-place.png')
  }
  closeModal() {
    this.$emit('close-modal')
  }
  async goLink() {
    this.closeModal()
    let url = this.data.jumpUrl
    if (!url) return
    let translateRes = await translateUrl(this.data.jumpUrl || '')
    // 微页面组件内容点击埋点
    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName: this.data.desc || '不满足条件弹窗',
        JumpType: translateRes.jumpType,
        JumpContentName: translateRes.jumpName,
        JumpContentID: translateRes.jumpId,
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        ['p4', 'JumpType_JumpContentID_JumpContentName'],
      ]
    )
    url && MicroUtils.goLink(url, env)
  }
}
